import { Component } from '@angular/core';
import { LayoutModule } from '../../../layout/layout.module';
import { SettlementsModule } from '../../../../settlements/settlements.module';

@Component({
  selector: 'app-settlements-dashboard-page',
  standalone: true,
  imports: [LayoutModule, SettlementsModule],
  templateUrl: './settlements-dashboard-page.component.html',
})
export class SettlementsDashboardPageComponent { }
